import React, { useState, useEffect } from "react";
import FullScreenModal from "../FullScreenModal/FullScreenModal";
import { State } from "../../state/state";
import "./Compendium.css";
import CompendiumItem from "../CompendiumItem/CompendiumItem";
import { IReducer } from "../../state/reducer";
import { BrickInventoryEntry } from "../../state/BrickInventory/BrickInventory";

interface CompendiumProps extends IReducer {
  isOpen: boolean;
  onClose: (arg0: boolean) => void;
}

const renderProgress = (state: State) => {
  let found = 0;

  state.bricks.forEach((value, _) => {
    if (value.amount >= 0) found++;
  });

  return found + "/" + (state.bricks.size - 1).toString();
};

const Compendium: React.FC<CompendiumProps> = ({
  isOpen,
  onClose,
  state,
  dispatch,
}) => {
  const [visibleBricks, setVisibleBricks] = useState<BrickInventoryEntry[]>([]);
  const [isChecked, setIsChecked] = useState(false);
  const [activeSearch, setActiveSearch] = useState<string>("");

  useEffect(() => {
    let filteredBricks: BrickInventoryEntry[] = [];

    state.bricks.forEach((brick, _) => {
      // Hide found
      if (isChecked) {
        if (Number.isNaN(brick.amount)) {
          filteredBricks.push(brick);
        }
      } else {
        filteredBricks.push(brick);
      }
    });

    // Step 1: Apply search filter if activeSearch is not empty
    if (activeSearch.trim() !== "") {
      filteredBricks = filteredBricks.filter((brick) =>
        brick.name.toLowerCase().includes(activeSearch.toLowerCase()),
      );
    }

    setVisibleBricks(filteredBricks);

    // Viewports will auto-sync on next frame via GlobalCanvasManager
    // No manual sync needed - the RAF throttling handles it
  }, [activeSearch, isChecked, isOpen]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setActiveSearch(event.target.value); // Update state with the new input value
  };

  const handleHideFoundChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setIsChecked(event.target.checked);
  };

  const closeFullScreenModal = () => {
    setIsChecked(false);
    setActiveSearch("");
    onClose(false);
  };

  return (
    <FullScreenModal
      header={"Compendium"}
      isOpen={isOpen}
      onClose={() => closeFullScreenModal()}
      helpURL="https://www.google.com"
    >
      <div className="compendiumContainer">
        <div className="compendiumSearch">
          <div className="compendiumFilters">
            <div className="dropdownSelectContainer">
              <input
                type="text"
                className="searchInput compendiumSearchInput"
                onChange={handleInputChange} // Capture the input change event
                placeholder={"Search"}
              />
            </div>
            <input
              className="compendiumFoundCheckbox"
              type="checkbox"
              checked={isChecked}
              onChange={handleHideFoundChange}
            />
            <span className="hideFound">Hide found</span>
          </div>
          <div className="compendiumProgress">
            Progress: {renderProgress(state)}
          </div>
        </div>
        <div className="compendiumItems">
          {visibleBricks.map((brick) => (
            <div key={brick.id}>
              <CompendiumItem
                state={state}
                dispatch={dispatch}
                id={brick.id}
                hideFound={isChecked}
              />
            </div>
          ))}
        </div>
      </div>
    </FullScreenModal>
  );
};

export default Compendium;
